import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, NgModule } from "@angular/core";
import * as _ from "lodash";
import { Observable } from "rxjs";
import { globalConst } from "src/app/shared/helpers/constants";
import { AuthService } from "src/app/shared/services/auth.service";

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token =
      localStorage.getItem(globalConst.localStorage.tokenName) || null;
    let reqClone: HttpRequest<any>;
    let cloned = false;

    /*  if (
      _.isEmpty(req.url.match("/auth/login")) &&
      _.isEmpty(req.url.match("user/reset-password/")) &&
      (this.authService.isTokenExpired() ||
        _.isEmpty(this.authService.getUserLogged()))
    ) {
      location.reload();
      return new Observable();
    } */

    const centerWeb = req.url.indexOf("CenterWeb");

    if (!_.isNull(token) && centerWeb <= 0) {
      reqClone = req.clone({
        headers: req.headers
          .set("Content-Type", "application/json")
          .set("Authorization", `Bearer ${token}`)
          .set("x-userEmail", this.authService.getUserLogged().email)
          .set(
            "x-umovmeEnv",
            `${localStorage.getItem(globalConst.localStorage.environment)}`
          ),
      });
      cloned = true;
    } else {
      reqClone = req.clone({
        headers: req.headers.set("Content-Type", "application/json"),
      });
    }

    if (cloned) {
      return next.handle(reqClone);
    } else {
      return next.handle(req);
    }
  }
}

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true,
    },
  ],
})
export class AuthInterceptorModule {}
